import {ConnectionStatus, TERMINAL_SESSION_STATES} from '../types/session'
import type {SessionState as SessionStateType} from '../types/session'

/**
 * Computes connection status for a CLI session.
 * Returns undefined when isCLI is false.
 */
export function computeConnectionStatus(
  staleAt: string | undefined,
  isCLI: boolean,
  sessionState?: SessionStateType,
  dataUpdatedAt?: number,
): ConnectionStatus | undefined {
  if (!isCLI) return undefined

  if (sessionState && TERMINAL_SESSION_STATES.has(sessionState)) {
    return ConnectionStatus.Disconnected
  }

  if (!staleAt) return ConnectionStatus.Disconnected

  const deadline = new Date(staleAt).getTime()
  if (Date.now() < deadline) return ConnectionStatus.Connected

  // Deadline has passed — but if our data is older than the deadline,
  // we don't yet have a server response that reflects the post-deadline state.
  if (dataUpdatedAt !== undefined && dataUpdatedAt < deadline) {
    return ConnectionStatus.Connected
  }

  return ConnectionStatus.Disconnected
}
